import { RouteRecordRaw } from 'vue-router';

const router: ({
  redirect: string; path: string; component: () => any; children: ({ path: string; component: () => any; name: string } | { path: string; component: () => any; name: string } | { redirect: string; path: string; component: () => any; children: ({ path: string; component: () => any; name: string } | { path: string; component: () => any; name: string } | { path: string; component: () => any; name: string } | { path: string; component: () => any; name: string; props: boolean })[]; name: string } | { redirect: string; path: string; component: () => any; children: ({ path: string; component: () => any; name: string } | { path: string; component: () => any; name: string } | { path: string; component: () => any; name: string; props: boolean } | { redirect: { name: string }; path: string; component: () => any; children: ({ path: string; component: () => any; name: string } | { path: string; component: () => any; name: string } | { path: string; component: () => any; name: string } | { path: string; component: () => any; name: string } | { path: string; component: () => any; name: string })[]; name: string; props: boolean })[]; name: string } | { redirect: string; path: string; component: () => any; children: ({ path: string; component: () => any; name: string } | { path: string; component: () => any; name: string; props: boolean })[]; name: string } | { redirect: string; path: string; component: () => any; children: ({ path: string; component: () => any; name: string } | { path: string; component: () => any; name: string } | { path: string; component: () => any; name: string; props: boolean } | { path: string; component: () => any; name: string; props: boolean } | { path: string; component: () => any; name: string; props: boolean } | { path: string; component: () => any; name: string; props: boolean })[]; name: string } | { redirect: string; path: string; component: () => any; children: ({ path: string; component: () => any; name: string } | { path: string; component: () => any; name: string } | { path: string; component: () => any; name: string; props: boolean } | { path: string; component: () => any; name: string; props: boolean })[]; name: string } | { path: string; component: () => any; children: ({ path: string; component: () => any; name: string } | { path: string; component: () => any; name: string } | { path: string; component: () => any; name: string; props: boolean })[]; name: string } | { path: string; component: () => any; children: ({ path: string; component: () => any; name: string } | { path: string; component: () => any; name: string } | { path: string; component: () => any; name: string; props: boolean })[]; name: string } | { redirect: string; path: string; component: () => any; children: ({ path: string; component: () => any; name: string } | { path: string; component: () => any; name: string; props: boolean } | { path: string; component: () => any; name: string } | { path: string; component: () => any; name: string; props: boolean })[]; name: string } | { redirect: string; path: string; component: () => any; children: ({ path: string; component: () => any; name: string } | { path: string; component: () => any; name: string; props: boolean } | { path: string; component: () => any; name: string } | { path: string; component: () => any; name: string; props: boolean })[]; name: string } | { redirect: string; path: string; component: () => any; children: ({ path: string; component: () => any; name: string } | { path: string; component: () => any; name: string } | { path: string; component: () => any; name: string; props: boolean } | { redirect: { name: string }; path: string; component: () => any; children: any[]; name: string; props: boolean })[]; name: string } | { redirect: string; path: string; component: () => any; children: ({ path: string; component: () => any; name: string } | { path: string; component: () => any; name: string } | { path: string; component: () => any; name: string; props: boolean } | { redirect: { name: string }; path: string; component: () => any; children: ({ path: string; component: () => any; name: string } | { path: string; component: () => any; name: string } | { path: string; component: () => any; name: string } | { path: string; component: () => any; name: string })[]; name: string; props: boolean })[]; name: string } | { redirect: string; path: string; component: () => any; children: ({ path: string; component: () => any; name: string } | { path: string; component: () => any; name: string; props: boolean })[]; name: string } | { redirect: string; path: string; component: () => any; children: ({ path: string; component: () => any; name: string } | { path: string; component: () => any; name: string } | { path: string; component: () => any; name: string; props: boolean })[]; name: string } | { redirect: string; path: string; component: () => any; children: ({ path: string; component: () => any; name: string } | { path: string; component: () => any; name: string } | { path: string; component: () => any; name: string; props: boolean })[]; name: string } | { path: string; children: ({ path: string; component: () => any; name: string } | { path: string; component: () => any; name: string })[]; name: string })[]; name: string
} | { redirect: { name: string }; path: string; component: () => any; children: ({ path: string; component: () => any; name: string } | { path: string; component: () => any; name: string } | { path: string; component: () => any; name: string })[] } | { path: string; component: () => any; name: string } | { path: string; component: () => any; name: string } | { redirect: string; path: string })[] = [
  {
    path: '/admin-panel',
    name: 'admin-panel',
    redirect: '/admin-panel/dashboard',
    component: () => import('@/modules/admin/layout/Layout.vue'),
    children: [
      {
        path: 'dashboard',
        name: 'admin-dashboard',
        component: () => import('@/modules/admin/views/DashboardAdmin.vue'),
      },
      {
          path: 'profile',
          name: 'profile',
          component: () =>
              import('@/modules/admin/views/settings/Profile.vue'),
      },
      {
        path: 'subscription-packages',
        name: 'admin-subscription-packages',
        redirect: '/subscription-packages/list',
        component: () =>
          import('@/modules/admin/views/subscription-packages/Main.vue'),
        children: [
          {
            path: 'general',
            name: 'general-settings',
            component: () =>
              import('@/modules/admin/views/general/Update.vue'),
          },
          {
            path: 'list',
            name: 'admin-subscription-packages-list',
            component: () =>
              import('@/modules/admin/views/subscription-packages/List.vue'),
          },
          {
            path: 'create',
            name: 'admin-subscription-packages-create',
            component: () =>
              import('@/modules/admin/views/subscription-packages/Create.vue'),
          },
          {
            path: 'edit/:id',
            name: 'admin-subscription-packages-edit',
            props: true,
            component: () =>
              import('@/modules/admin/views/subscription-packages/Create.vue'),
          },
        ],
      },
      {
        path: 'venders',
        name: 'admin-venders',
        redirect: '/venders/list',
        component: () => import('@/modules/admin/views/venders/MainVender.vue'),
        children: [
          {
            path: 'list',
            name: 'admin-venders-list',
            component: () =>
              import('@/modules/admin/views/venders/ListVender.vue'),
          },
          {
            path: 'create',
            name: 'admin-venders-create',
            component: () =>
              import('@/modules/admin/views/venders/CreateVender.vue'),
          },
          {
            path: 'edit/:id',
            name: 'admin-venders-edit',
            props: true,
            component: () =>
              import('@/modules/admin/views/venders/EditVender.vue'),
          },
          {
            path: 'view/:id',
            name: 'admin-venders-view',
            props: true,
            redirect: { name: 'admin-venders-view-information' },
            component: () =>
              import('@/modules/admin/views/venders/ViewVendor.vue'),
            children: [
              {
                path: 'payments',
                name: 'admin-venders-view-payments',
                component: () =>
                  import(
                    '@/modules/admin/views/venders/viewTabs/PaymentTab.vue'
                  ),
              },
              {
                path: 'referral-vendors',
                name: 'admin-venders-view-referral-vendors',
                component: () =>
                  import(
                    '@/modules/admin/views/venders/viewTabs/referralVendors.vue'
                  ),
              },
              {
                path: 'subscribe-payments',
                name: 'admin-venders-view-subscribe-payments',
                component: () =>
                  import(
                    '@/modules/admin/views/venders/viewTabs/SubscribePaymentTab.vue'
                  ),
              },
              {
                path: 'create-payments',
                name: 'admin-venders-view-create-payments',
                component: () =>
                  import(
                    '@/modules/admin/views/venders/CreatePayments.vue'
                  ),
              },
              {
                path: 'information',
                name: 'admin-venders-view-information',
                component: () =>
                  import('@/modules/admin/views/venders/viewTabs/InfoTab.vue'),
              },
            ],
          },
        ],
      },
      {
        path: 'subscriptions',
        name: 'admin-subscriptions',
        redirect: '/subscriptions/list',
        component: () => import('@/modules/admin/views/subscriptions/Main.vue'),
        children: [
          {
            path: 'list',
            name: 'admin-subscriptions-list',
            component: () =>
              import('@/modules/admin/views/subscriptions/List.vue'),
          },
          {
            path: 'view/:id',
            name: 'subscriptions-view',
            props: true,
            component: () =>
              import('@/modules/admin/views/subscriptions/View.vue'),
          },
        ],
      },
      {
        path: 'marketplaces',
        name: 'admin-marketplaces',
        redirect: '/marketplaces/list',
        component: () => import('@/modules/admin/views/marketplaces/Main.vue'),
        children: [
          {
            path: 'list',
            name: 'admin-marketplaces-list',
            component: () =>
              import('@/modules/admin/views/marketplaces/List.vue'),
          },
          {
            path: 'create',
            name: 'admin-marketplaces-create',
            component: () =>
              import('@/modules/admin/views/marketplaces/Create.vue'),
          },
          {
            path: 'edit/:id',
            name: 'admin-marketplaces-edit',
            props: true,
            component: () =>
              import('@/modules/admin/views/marketplaces/Create.vue'),
          },
          {
            path: 'mapping-categories/:marketPlaceId/:marketPlaceCategoryId',
            name: 'admin-marketplaces-mapping',
            props: true,
            component: () =>
              import('@/modules/admin/views/marketplaces/MappingMarketPlaceCategories.vue'),
          },
          {
            path: 'properties/:marketPlaceCategoryId/:mainCategoryId',
            name: 'admin-marketplaces-properties',
            props: true,
            component: () =>
              import('@/modules/admin/views/marketplaces/Properties.vue'),
          },
          {
            path: 'mapping-properties/:mainCategoryId/:marketplacePropertyId',
            name: 'admin-marketplaces-property-mapping',
            props: true,
            component: () =>
              import('@/modules/admin/views/marketplaces/MappingMarketPlaceProperties.vue'),
          },
        ],
      },
      {
        path: 'users',
        name: 'admin-users',
        redirect: '/users/list',
        component: () => import('@/modules/admin/views/users/Main.vue'),
        children: [
          {
            path: 'list',
            name: 'admin-users-list',
            component: () => import('@/modules/admin/views/users/List.vue'),
          },
          {
            path: 'create',
            name: 'admin-users-create',
            component: () => import('@/modules/admin/views/users/Create.vue'),
          },
          {
            path: 'edit/:id',
            name: 'admin-users-edit',
            props: true,
            component: () => import('@/modules/admin/views/users/Create.vue'),
          },
          
          {
            path: 'categories/:id',
            name: 'admin-marketplaces-categories',
            props: true,
            component: () =>
              import('@/modules/admin/views/marketplaces/Categories.vue'),
          },
        ],
      },
      {
        path: 'coupons',
        name: 'admin-coupons',
        component: () => import('@/modules/admin/views/coupons/Main.vue'),
        children: [
          {
            path: 'list',
            name: 'admin-coupons-list',
            component: () => import('@/modules/admin/views/coupons/List.vue'),
          },
          {
            path: 'create',
            name: 'admin-coupons-create',
            component: () => import('@/modules/admin/views/coupons/Create.vue'),
          },
          {
            path: 'edit/:id',
            name: 'admin-coupons-edit',
            props: true,
            component: () => import('@/modules/admin/views/coupons/Create.vue'),
          },
        ],
      },
      {
        path: 'support',
        name: 'support',
        component: () => import('@/modules/admin/views/support/Main.vue'),
        children: [
          {
            path: 'shipping-list',
            name: 'admin-support-shipping-list',
            component: () => import('@/modules/admin/views/support/Shipping.vue'),
          },
          {
            path: 'shipping-company-requests-list',
            name: 'admin-shipping-company-requests-list',
            component: () => import('@/modules/admin/views/support/ShippingCompany.vue'),
          },
          {
            path: 'view/:id',
            name: 'support-view',
            props: true,
            component: () =>
              import('@/modules/admin/views/support/ShippingCompanyView.vue'),
          },
        ],
      },
      {
        path: 'categories',
        name: 'admin-categories',
        redirect: '/categories/list',
        component: () => import('@/modules/admin/views/categories/Main.vue'),
        children: [
          {
            path: 'list',
            name: 'admin-categories-list',
            component: () =>
              import('@/modules/admin/views/categories/List.vue'),
          },
          {
            path: 'edit/:id',
            name: 'admin-categories-edit',
            props: true,
            component: () =>
              import('@/modules/admin/views/categories/Create.vue'),
          },
          {
            path: 'create',
            name: 'admin-categories-create',
            component: () =>
              import('@/modules/admin/views/categories/Create.vue'),
          },
          {
            path: 'view/:id',
            name: 'admin-categories-view',
            props: true,
            component: () =>
              import('@/modules/admin/views/categories/View.vue'),
          },
        ],
      },
      {
        path: 'properties',
        name: 'admin-properties',
        redirect: '/properties/list',
        component: () => import('@/modules/admin/views/properties/Main.vue'),
        children: [
          {
            path: 'list',
            name: 'admin-properties-list',
            component: () =>
              import('@/modules/admin/views/properties/List.vue'),
          },
          {
            path: 'edit/:id',
            name: 'admin-properties-edit',
            props: true,
            component: () =>
              import('@/modules/admin/views/properties/Create.vue'),
          },
          {
            path: 'create',
            name: 'admin-properties-create',
            component: () =>
              import('@/modules/admin/views/properties/Create.vue'),
          },
          {
            path: 'view/:id',
            name: 'admin-properties-view',
            props: true,
            component: () =>
              import('@/modules/admin/views/properties/View.vue'),
          },
        ],
      },
      {
        path: 'referral-code-groups',
        name: 'admin-referral-code-groups',
        redirect: '/referral-code-groups/list',
        component: () => import('@/modules/admin/views/referral-code-groups/Main.vue'),
        children: [
          {
            path: 'list',
            name: 'admin-referral-code-groups-list',
            component: () =>
              import('@/modules/admin/views/referral-code-groups/List.vue'),
          },
          {
            path: 'create',
            name: 'admin-referral-code-groups-create',
            component: () =>
              import('@/modules/admin/views/referral-code-groups/Create.vue'),
          },
          {
            path: 'edit/:id',
            name: 'admin-referral-code-groups-edit',
            props: true,
            component: () =>
              import('@/modules/admin/views/referral-code-groups/Create.vue'),
          },
          {
            path: 'view/:id',
            name: 'admin-referral-code-groups-view',
            props: true,
            redirect: { name: 'admin-referral-code-groups-view-information' },
            component: () =>
              import('@/modules/admin/views/referral-code-groups/View.vue'),
            children: [
              
            ],
          },
        ],
      },
      {
        path: 'partners',
        name: 'admin-partners',
        redirect: '/partners/list',
        component: () => import('@/modules/admin/views/partners/Main.vue'),
        children: [
          {
            path: 'list',
            name: 'admin-partners-list',
            component: () =>
              import('@/modules/admin/views/partners/List.vue'),
          },
          {
            path: 'create',
            name: 'admin-partners-create',
            component: () =>
              import('@/modules/admin/views/partners/Create.vue'),
          },
          {
            path: 'edit/:id',
            name: 'admin-partners-edit',
            props: true,
            component: () =>
              import('@/modules/admin/views/partners/Create.vue'),
          },
          {
            path: 'view/:id',
            name: 'admin-partners-view',
            props: true,
            redirect: { name: 'admin-partners-view-information' },
            component: () =>
              import('@/modules/admin/views/partners/View.vue'),
            children: [
              {
                path: 'referral-sellers',
                name: 'admin-partners-view-referralSellers',
                component: () =>
                  import(
                    '@/modules/admin/views/partners/viewTabs/referralSellers.vue'
                  ),
              },
              {
                path: 'partner-information',
                name: 'admin-partners-view-information',
                component: () =>
                  import('@/modules/admin/views/partners/viewTabs/InfoTab.vue'),
              },
              {
                path: 'partner-PaymentTab',
                name: 'admin-partners-view-PaymentTab',
                component: () =>
                  import('@/modules/admin/views/partners/viewTabs/PaymentTab.vue'),
              },
              {
                path: 'partner-payment-create',
                name: 'partner-payment-create',
                component: () =>
                  import('@/modules/admin/views/partners/CreatePayments.vue'),
              },
            ],
          },
        ],
      },
      {
        path: 'contact',
        name: 'admin-contact',
        redirect: '/contact/list',
        component: () => import('@/modules/admin/views/contact/Main.vue'),
        children: [
          {
            path: 'list',
            name: 'admin-contact-list',
            component: () =>
              import('@/modules/admin/views/contact/List.vue'),
          },  
          {
            path: 'view/:id',
            name: 'admin-contact-view',
            props: true,
            component: () =>
              import('@/modules/admin/views/contact/Create.vue'),
          },    
        ],
      },
      {
        path: 'blogs',
        name: 'admin-blogs',
        redirect: '/blogs/list',
        component: () => import('@/modules/admin/views/blogs/Main.vue'),
        children: [
          {
            path: 'list',
            name: 'admin-blogs-list',
            component: () =>
              import('@/modules/admin/views/blogs/List.vue'),
          },
          {
            path: 'create',
            name: 'admin-blogs-create',
            component: () =>
              import('@/modules/admin/views/blogs/Create.vue'),
          },
          {
            path: 'edit/:id',
            name: 'admin-blogs-edit',
            props: true,
            component: () =>
              import('@/modules/admin/views/blogs/Create.vue'),
          },
        
        ],
      },
      {
        path: 'contents',
        name: 'admin-contents',
        redirect: '/contents/list',
        component: () => import('@/modules/admin/views/contents/Main.vue'),
        children: [
          {
            path: 'list',
            name: 'admin-contents-list',
            component: () =>
              import('@/modules/admin/views/contents/List.vue'),
          },
          {
            path: 'create',
            name: 'admin-contents-create',
            component: () =>
              import('@/modules/admin/views/contents/Create.vue'),
          },
          {
            path: 'edit/:id',
            name: 'admin-contents-edit',
            props: true,
            component: () =>
              import('@/modules/admin/views/contents/Create.vue'),
          },
        
        ],
      },
      {
        path: 'reports',
        name: 'admin-reports',
        children: [
          {
            path: 'partners',
            name: 'admin-reports-partners',
            component: () =>
              import('@/modules/admin/views/reports/partners.vue'),
          },
          {
            path: 'coupons',
            name: 'admin-reports-coupons',
            component: () =>
              import('@/modules/admin/views/reports/coupons/Index.vue'),
          },
          {
            path: 'sales',
            name: 'admin-reports-sales',
            component: () =>
              import('@/modules/admin/views/reports/sales/Index.vue'),
          },
          {
            path: 'users',
            name: 'admin-reports-users',
            component: () =>
              import('@/modules/admin/views/reports/users/Index.vue'),
          },
        
        ],
      },
      {
        path: 'terms-conditions',
        name: 'admin-terms-conditions',
        component: () => import('@/modules/admin/views/settings/terms-conditions.vue'),
      },
    ],
  },
  {
    path: '/admin-panel',
    redirect: {name:'admin-sign-in'},
    component: () => import('../layout/Auth.vue'),
    children: [
      {
        path: 'sign-in',
        name: 'admin-sign-in',
        component: () => import('@/modules/admin/views/auth/SignIn.vue'),
      },
      {
        path: 'reset-password',
        name: 'admin-reset-password',
        component: () => import('@/modules/admin/views/auth/ResetPassword.vue'),
      },
      {
        path: 'forget-password',
        name: 'admin-forget-password',
        component: () => import('@/modules/admin/views/auth/ForgetPassword.vue'),
      },
    ],
  },
  {
    // the 404 route, when none of the above matches
    path: '/404',
    name: '404',
    component: () =>
      import('@/modules/common/views/authentication/Error404.vue'),
  },
  {
    // register vender
    path: '/register/vender',
    name: 'register-vender',
    component: () => import('@/modules/vender/views/registerVender.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404',
  },
];

export default router;
